export const assemblyParts =
    [
        {
            "id": 'assembly', "title": "Assembly", "group": "assemblyParts"
        }, {
            "id": 'individual parts', "title": "Individual parts", "group": "assemblyParts"
        },

    ]


export const quotePreviously =
    [
        {
            "id": 0, "title": "Yes", "group": "quotePreviously"
        }, {
            "id": 1, "title": "No ", "group": "quotePreviously"
        },

    ]


export const quoteSimilarPartPreviously =
    [
        {
            "id": 0, "title": "Yes", "group": "quoteSimilarPartPreviously"
        }, {
            "id": 1, "title": "No ", "group": "quoteSimilarPartPreviously"
        },

    ]


export const typeOfEnclosures =
    [
         {
             value: 'Sheet Metal', title: "Sheet Metal"
        },

        {
             value: 'CNC Machined', title: "CNC Machined"
        },

        {
             value: 'Bus Bar', title: "Bus Bar"
        },

        {
             value: 'Customizable Diecast Enclosure', title: "Customizable Diecast Enclosure"
        },
        {
             value: '3D Printing', title: "3D Printing"
        },
        {
             value: 'Gasket', title: "Gasket"
        },

        {
             value: 'Other', title: "Other"
        },

    ]



